/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TInsuranceAcceptModel, IMappers, TInsuranceAcceptResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { TPublicV2InsuranceAcceptResponse } from '../../../entities/response/PublicV2InsuranceAcceptResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createInsuranceAcceptModel(): TInsuranceAcceptModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v2/insurance/accept/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IInsuranceAcceptOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchInsuranceAccept<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IInsuranceAcceptOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TInsuranceAcceptResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createInsuranceAcceptModel(),
    config,
  )) as FetchResponse<TInsuranceAcceptResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicV2InsuranceAcceptResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TInsuranceAcceptResponse>;
}
